export default "__VITE_ASSET__d8b06e29__"